import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { ArticuloSerial } from '../types/serial.types';

interface SerialStore {
  seriales: ArticuloSerial[];
  loading: boolean;
  setSeriales: (seriales: ArticuloSerial[]) => void;
  setLoading: (loading: boolean) => void;
}

export const useSerialStore = create<SerialStore>()(
  devtools(
    (set) => ({
      seriales: [],
      loading: false,
      setSeriales: (seriales) => set({ seriales }),
      setLoading: (loading) => set({ loading }),
    }),
    { name: 'SerialStore' }
  )
);
